import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../components/Common/TableContainer';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useMutation, useQueryClient } from 'react-query';

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
//Import Flatepicker
import 'flatpickr/dist/themes/material_blue.css';
import Flatpickr from 'react-flatpickr';

import {
  addNewClaim as onAddNewClaim,
  updateClaim as onUpdateClaim,
  setClaimSummary,
} from 'store/actions';

import { PaymentStatus } from './ClaimCol';

//redux
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import ClaimsModal from './ClaimModal';

import {
  Col,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
  Card,
  CardBody,
} from 'reactstrap';
import moment from 'moment';
import { useAuth } from 'hooks/useAuth';
import { getSearchColumns, sumArray } from 'utils/tools';
import { ToastContainer } from 'react-toastify';
import { getAssignedClaimsByAreaIdApi, getAllClaimApi } from 'api/claim';
import { getClaimStatusCountsApi } from 'api/report';
import { useRole } from 'hooks/useRole';
import MainFilter from 'components/Common/MainFilter';

function Claim() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { isAuthenticated } = useAuth();
  const [pages, setPages] = useState(0);
  const queryClient = useQueryClient();
  const {
    isFacilitator,
    isSiteCord,
    isCountyCoordinator,
    isClusterLeader,
    isFinance,
    isDirector,
    isAdmin,
    isSuperAdmin,
    isData,
    addresses,
    isRegionalCountyCoordinator
  } = useRole();
  const { wardId, constituencyId, countyId, regionId } = isAuthenticated
    ? addresses[0]
    : {};
  const [addressData, setAddressData] = useState({});

  const { claimSummary } = useSelector((state) => ({
    claimSummary: state.reports.claims,
  }));

  const claimsCardData = [
    {
      title: 'Total Claims',
      iconClass: 'bx bx-user',
      description: claimSummary?.length
        ? sumArray(claimSummary, 'totalClaims')
        : 0,
    },
    {
      title: 'Approved',
      iconClass: 'bx bx-check-circle',
      description: claimSummary?.length
        ? sumArray(claimSummary, 'totalProcessed')
        : 0,
    },
    {
      title: 'Processing',
      iconClass: 'bx bx-pause-circle',
      description: claimSummary?.length
        ? sumArray(claimSummary, 'totalPending')
        : 0,
    },
    {
      title: 'Rejected',
      iconClass: 'bx bx-error-circle',
      description: claimSummary?.length
        ? sumArray(claimSummary, 'totalDeclined')
        : 0,
    },
  ];
  const dateFormat = 'DD-MM-YYYY';
  const [pagination, setPagination] = useState({
    pageSize: 10,
    pageNumber: 1,
    sortBy: 'id',
    ascendingSort: false,
    wardIds: getSearchColumns()?.find((t) => t?.name === 'wardIds')?.value,
    searchColumns: [
      ...(isFacilitator
        ? [
          {
            name: 'wardId',
            value: wardId,
          },
        ]
        : []),
      ...(isCountyCoordinator
        ? [
          {
            name: 'countyIds',
            values: addresses?.map((c) => c.countyId),
          },
        ]
        : []),
      ...(isRegionalCountyCoordinator
        ? [
          {
            name: 'regionIds',
            values: addresses?.map((c) => c.regionId),
          },
        ]
        : []),
      ...(isClusterLeader
        ? [
          {
            name: 'constituencyIds',
            values: addresses?.map((c) => c.constituencyId),
          },
        ]
        : []),
      ...(isSiteCord
        ? [
          {
            name: 'wardIds',
            values: addresses?.map((c) => c.wardId),
          },
          {
            name: 'constituencyId',
            value: addresses[0]?.constituencyId,
          },
        ]
        : []),
      {
        name: 'endDate',
        value: moment().format(dateFormat),
      },
      {
        name: 'startDate',
        value: moment().startOf('year').format(dateFormat),
      },
    ],
  });

  //meta title
  document.title = 'Claims | SUN Welfare Administration System';

  const [modal, setModal] = useState(false);
  const [modal1, setModal1] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [member, setClaim] = useState(null);

  const { mutate: mutateClaimCounts, data } = useMutation(
    (payload) => getClaimStatusCountsApi(payload),
    {
      onSuccess: (res) => {
        dispatch(setClaimSummary(res?.data));
      },
      onSettled: () => {
        queryClient.invalidateQueries('get-all-counties');
      },
    },
  );

  const {
    mutate: mutateClaims,
    isLoading: isLoadingClaims,
    data: claimsData,
  } = useMutation((payload) => getAllClaimApi(payload), {
    onSuccess: (res) => {
      res.pages > 0 && setPages(res.pages);
    },
    onSettled: () => {
      queryClient.invalidateQueries('get-all-counties');
    },
  });

  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      fullNames: (member && member.fullNames) || '',
      reportedDate: (member && member.reportedDate) || '',
      groupName: (member && member.groupName) || '',
      deceasedName: (member && member.deceasedName) || '',
      status: (member && member.status) || 'Paid',
      badgeclass: (member && member.badgeclass) || 'success',
      memberStatus: (member && member.memberStatus) || 'Mastercard',
    },
    validationSchema: Yup.object({
      fullNames: Yup.string()
        .matches(/[0-9\.\-\s+\/()]+/, 'Please Enter Valid Claim Id')
        .required('Please Enter Your Claim Id'),
      reportedDate: Yup.string().required('Please Enter Your Billing Name'),
      groupName: Yup.string().required('Please Enter Your Claim Date'),
      deceasedName: Yup.string()
        .matches(/[0-9\.\-\s+\/()]+/, 'Please Enter Valid Amount')
        .required('Total Amount'),
      status: Yup.string().required('Please Enter Your Payment Status'),
      badgeclass: Yup.string().required('Please Enter Your Badge Class'),
      memberStatus: Yup.string().required('Please Enter Your Payment Method'),
    }),
    onSubmit: (values) => {
      if (isEdit) {
        const updateClaim = {
          id: member ? member.id : 0,
          fullNames: values.fullNames,
          reportedDate: values.reportedDate,
          groupName: values.groupName,
          deceasedName: values.deceasedName,
          status: values.status,
          memberStatus: values.memberStatus,
          badgeclass: values.badgeclass,
        };
        // update member
        dispatch(onUpdateClaim(updateClaim));
        validation.resetForm();
      } else {
        const newClaim = {
          id: Math.floor(Math.random() * (30 - 20)) + 20,
          fullNames: values['fullNames'],
          reportedDate: values['reportedDate'],
          groupName: values['groupName'],
          deceasedName: values['deceasedName'],
          status: values['status'],
          memberStatus: values['memberStatus'],
          badgeclass: values['badgeclass'],
        };
        // save new member
        dispatch(onAddNewClaim(newClaim));
        validation.resetForm();
      }
      toggle();
    },
  });

  const toggleViewModal = () => setModal1(!modal1);

  const selectClaimState = (state) => state.members;
  const ClaimProperties = createSelector(selectClaimState, (Claim) => ({
    members: generateFakeData(),
    // TO-DO return this for live data
    // members: Claim.members,
    loading: Claim.loading,
  }));

  useEffect(() => {
    mutateClaims({ ...pagination, pageNumber: pagination.pageNumber - 1 });
  }, []);

  useEffect(() => {
    const merged = Object.assign({}, ...pagination.searchColumns.map(p => ({ [p.name]: p.value })));
    getAssignedClaimsByAreaIdApi({
      ...merged,
      pageSize: pagination.pageSize,
      pageNumber: pagination.pageNumber - 1,
      startDate: pagination.searchColumns?.find((c) => c.name === 'startDate')?.value,
      endDate: pagination.searchColumns?.find((c) => c.name === 'endDate')?.value
    });
  }, [pagination]);

  const onChangePagination = ({ page, limit }, filters, sorter) => {
    let searchColumns = isEmpty(filters)
      ? pagination.searchColumns
      : [
        ...pagination.searchColumns,
        ...(filters?.id
          ? [
            {
              name: 'id',
              value: filters?.id,
            },
          ]
          : []),
        ...(filters?.firstName
          ? [
            {
              name: 'firstName',
              value: filters?.firstName,
            },
          ]
          : []),
        ...(filters?.lastName
          ? [
            {
              name: 'lastName',
              value: filters?.lastName,
            },
          ]
          : []),
        ...(filters?.email
          ? [
            {
              name: 'email',
              value: filters?.email,
            },
          ]
          : []),
        ...(filters?.claimNumber
          ? [
            {
              name: 'claimNumber',
              value: filters?.claimNumber,
            },
          ]
          : []),
        ...(filters?.mobileNumber1
          ? [
            {
              name: 'mobileNumber1',
              value: filters?.mobileNumber1,
            },
          ]
          : []),
      ];
    setPagination({
      ...pagination,
      pageNumber: page || pagination.pageNumber,
      pageSize: limit || pagination.pageSize,
      searchColumns,
    });
  };

  const toggle = () => {
    if (modal) {
      setModal(false);
      setClaim(null);
    } else {
      setModal(true);
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: () => (
          <div className="form-check font-size-16">
            <input className="form-check-input" type="checkbox" id="checkAll" />
            <label className="form-check-label" htmlFor="checkAll"></label>
          </div>
        ),
        accessor: '#',
        width: '20px',
        filterable: true,
        Cell: (cellProps) => (
          <div className="form-check font-size-16">
            <input className="form-check-input" type="checkbox" id="checkAll" />
            <label className="form-check-label" htmlFor="checkAll"></label>
          </div>
        ),
      },
      {
        Header: 'ID',
        accessor: 'id',
        filterable: true,
        Cell: (cellProps) => {
          return <span>{cellProps.value}</span>;
        },
      },
      {
        Header: 'PRINCIPAL MEMBER',
        accessor: (row) =>
          `${row.member?.firstName || ''} ${row.member.lastName || ''}`,
        filterable: true,
        Cell: (cellProps) => {
          return <span>{cellProps.value}</span>;
        },
      },
      {
        Header: 'DATE OF DEATH',
        accessor: 'deathCertificate.deathDate',
        filterable: true,
        Cell: (cellProps) => {
          return (
            <span>{moment(cellProps.value).format('DD MMM YYYY')}</span>
          );
        },
      },
      {
        Header: 'REPORTED DATE',
        accessor: 'reportedDateTime',
        filterable: true,
        Cell: (cellProps) => {
          return (
            <span>{moment(cellProps.value).format('DD MMM YYYY h:mm A')}</span>
          );
        },
      },
      {
        Header: 'Claim Number',
        accessor: 'claimNumber',
        filterable: true,
        Cell: (cellProps) => {
          return <span>{cellProps.value}</span>;
        },
      },
      {
        Header: 'Claim Amount',
        accessor: 'claimAmount',
        filterable: true,
        Cell: ({ value }) => {
          return <span>{value ? Number(value).toLocaleString() : "0"}</span>;
        },
      },
      {
        Header: 'DECEASED NAME',
        accessor: (row) =>
          `${row.deathCertificate?.firstName || ''} ${row.deathCertificate?.lastName || ''
          }`,
        filterable: true,
        Cell: (cellProps) => {
          return <span>{cellProps.value}</span>;
        },
      },
      {
        Header: 'DECEASED AGE',
        accessor: 'deathCertificate.age',
        filterable: true,
        Cell: ({ value }) => {
          return <span>{value !== undefined && value !== null ? Math.round(value) : "N/A"}</span>;
        },
      },
      {
        Header: 'APPROVAL STATUS',
        accessor: 'status',
        Cell: (cellProps) => {
          return <PaymentStatus {...cellProps} />;
        },
      },
      {
        Header: 'APPROVED BY',
        accessor: 'claimStatus.destinationRole',
        Cell: (cellProps) => {
          return <span>{cellProps.value}</span>;
        },
      },
    ],
    [],
  );

  const onSearch = (data) => {
    const searchColumns = [];
    if (!isEmpty(data)) {
      if (isFacilitator) {
        searchColumns.push({ name: 'wardId', value: address?.wardId });
      }
      if (isSiteCord && data.wardId) {
        searchColumns.push(data?.wardId);
      } else {
        if (
          (isClusterLeader ||
            isFinance ||
            isDirector ||
            isAdmin ||
            isSuperAdmin) &&
          data?.regionId
        ) {
          searchColumns.push(data?.regionId);
        }
        if (data.wardId) {
          searchColumns.push(data?.wardId);
        }
        if (data.constituencyId) {
          searchColumns.push(data?.constituencyId);
        }
        if (data.countyId) {
          searchColumns.push(data?.countyId);
        }
      }
      data.startDate && searchColumns.push(data.startDate);
      data.endDate && searchColumns.push(data.endDate);
    }

    setPagination({ ...pagination, searchColumns });

    let add = {};
    searchColumns.forEach((a, i) => {
      add[a.name] = a.value;
    });
    setAddressData(add);
  };

  return (
    <React.Fragment>
      <ClaimsModal isOpen={modal1} toggle={toggleViewModal} />
      <Row>
        <Col xs="12">
          <Card>
            <CardBody>
              <TableContainer
                columns={columns}
                data={claimsData?.list || []}
                isGlobalFilter={true}
                isAddOptions={true}
                hasCreate={!isData}
                isPagination={true}
                filterable={false}
                iscustomPageSizeOptions={true}
                // showDelete
                hasSearch
                // showEdit={!isData}
                pages={pages}
                showView
                loading={isLoadingClaims}
                resource="claim"
                addText="Create New claim"
                tableClass="align-middle table-nowrap table-check"
                theadClass="table-light"
                pagination="pagination pagination-rounded justify-content-end mb-2"
                paginationData={pagination}
                onChangePagination={onChangePagination}
                searchByNames={[
                  {
                    value: 'claimNumber',
                    text: t('claims.claimNumber'),
                  },
                  {
                    value: 'email',
                    text: t('common.email'),
                  },
                  {
                    value: 'idNumber',
                    text: t('common.idNumber'),
                  },
                  {
                    value: 'firstName',
                    text: t('users.firstName'),
                  },
                  {
                    value: 'lastName',
                    text: t('users.lastName'),
                  },
                  {
                    value: 'mobileNumber1',
                    text: t('common.mobileNumber'),
                  },
                ]}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
      <ToastContainer />
    </React.Fragment>
  );
}
Claim.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default Claim;
